import { BannerFormData, BannerOrderItem, BannerListApiResponse, BannerGetApiResponse } from "../context/BannerContext/constants";
import { isFileObject } from "../utils/validation";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-banner",
	UPDATE: "/cms/update-banner",
	REMOVE: "/cms/remove-banner",
	GET: "/cms/get-banner-details",
	LIST: "/cms/get-banner-list",
	ORDER: "/cms/update-banner-orders"
};

export class BannerService {
	static async addBanner(bannerData: BannerFormData) {
		const formData = new FormData();

		if (bannerData.image && isFileObject(bannerData.image)) {
			formData.append("image", bannerData.image);
		}

		if (bannerData.smallImage && isFileObject(bannerData.smallImage)) {
			formData.append("smallImage", bannerData.smallImage);
		}

		if (bannerData.mobileImage && isFileObject(bannerData.mobileImage)) {
			formData.append("mobileImage", bannerData.mobileImage);
		}

		if (bannerData.bannerLocalizable && bannerData.bannerLocalizable.length > 0) {
			bannerData.bannerLocalizable.forEach((item, index) => {
				formData.append(`bannerLocalizable[${index}].url`, item.url || "");
				formData.append(`bannerLocalizable[${index}].firstHeaderName`, item.firstHeaderName || "");
				formData.append(`bannerLocalizable[${index}].headerName`, item.headerName || "");
				formData.append(`bannerLocalizable[${index}].bodyName`, item.bodyName || "");
				formData.append(`bannerLocalizable[${index}].culture`, item.culture || "");
			});
		}
		return await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
	}

	static async getBannerList(): Promise<BannerListApiResponse> {
		const response = await axiosInstance.get(ENDPOINTS.LIST);
		return response.data;
	}

	static async getBannerDetails(id: string): Promise<BannerGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?bannerId=${id}`);
		return response.data;
	}

	static async updateBanner(bannerData: BannerFormData) {
		const formData = new FormData();

		formData.append("bannerId", bannerData.bannerId ?? "");

		if (bannerData.image && isFileObject(bannerData.image)) {
			formData.append("image", bannerData.image);
		}

		if (bannerData.smallImage && isFileObject(bannerData.smallImage)) {
			formData.append("smallImage", bannerData.smallImage);
		}

		if (bannerData.mobileImage && isFileObject(bannerData.mobileImage)) {
			formData.append("mobileImage", bannerData.mobileImage);
		}

		if (bannerData.bannerLocalizable && bannerData.bannerLocalizable.length > 0) {
			bannerData.bannerLocalizable.forEach((item, index) => {
				formData.append(`bannerLocalizable[${index}].url`, item.url || "");
				formData.append(`bannerLocalizable[${index}].firstHeaderName`, item.firstHeaderName || "");
				formData.append(`bannerLocalizable[${index}].headerName`, item.headerName || "");
				formData.append(`bannerLocalizable[${index}].bodyName`, item.bodyName || "");
				formData.append(`bannerLocalizable[${index}].culture`, item.culture || "");
			});
		}

		return await axiosInstance.put(`${ENDPOINTS.UPDATE}`, formData);
	}

	static async removeBanner(id: string) {
		return await axiosInstance.delete(`${ENDPOINTS.REMOVE}?bannerId=${id}`);
	}

	static async updateBannerOrders(orders: BannerOrderItem[]) {
		const bannerList = orders
			.map((item, index) => ({
				bannerId: item.bannerId,
				displayOrder: index + 1,
			}))
			.filter((item, index) => item.displayOrder !== orders[index].displayOrder);

		if (bannerList.length === 0) {
			return { data: { result: { isSuccessful: true } } };
		}

		const formData = new FormData();

		bannerList.forEach((item, index) => {
			formData.append(`bannerList[${index}].bannerId`, item.bannerId || "");
			formData.append(`bannerList[${index}].displayOrder`, item.displayOrder.toString() || "");
		});

		return await axiosInstance.put(`${ENDPOINTS.ORDER}`, formData);
	}
}